import type { InterventionSectionTagAttributes } from "./intervention-section-tag.type";
import type { InterventionSectionItem } from "@/modules/intervention/intervention-section";

import { CheckCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import {
  getInterventionSectionObservation,
  isDynamicSection,
} from "@/modules/intervention/intervention-section";

import { getObservationColor } from "./intervention-section-tag.helper";

export const useInterventionSectionTag = (
  section: InterventionSectionItem
): InterventionSectionTagAttributes | undefined => {
  const { t } = useTranslation();

  // section is `InterventionSection`
  if (isDynamicSection(section)) {
    return {
      content: t("global:add"),
      icon: <PlusOutlined />,
    };
  }

  // section is:
  // - `InterventionSectionObservation`, or
  // - `InterventionSection` with `observation` object
  const observation = getInterventionSectionObservation(section);
  if (observation) {
    const { is_validated, progress } = observation;
    const { filled, total } = progress;

    const icon = is_validated ? <CheckCircleOutlined /> : undefined;
    const color = getObservationColor(observation);

    return {
      content: `${filled}/${total}`,
      icon,
      color,
    };
  }

  if ("field_count" in section) {
    return {
      content: `0/${section.field_count}`,
      color: "error",
    };
  }

  return undefined;
};
